import React from "react";
import { Link } from "react-router-dom";
const EcavoblackComponent = (props) => {
  return (
    <>
      <img src={props.currrentImg} alt="img2" />
      <div className="blackComponentEcavoText">
        <div className="blackHeading">{props.heading}</div>
        <p className="blackP">
          {props.text}
        </p>
        {/* <button className="blackButton">Know More</button> */}
        <Link to={props.Link} className="blackButton">
          Know More
        </Link>
      </div>
    </>
  );
};

export default EcavoblackComponent;


// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// import useAOS from "../hooks/useAOS";
// import AOS from "aos";

// const EcavoblackComponent = (props) => {
//   useAOS();

//   useEffect(() => {
//     AOS.refresh();
//   }, []);

//   return (
//     <div className="blackComponentEcavo">
//       <img src={props.currrentImg} alt="img2" data-aos="fade-in" />
//       <div className="blackComponentEcavoText">
//         <div className="blackHeading" data-aos="fade-up" data-aos-delay="300">
//           {props.heading}
//         </div>
//         <p className="blackP" data-aos="fade-up" data-aos-delay="400">
//           {props.text}
//         </p>
//         <Link
//           to={props.Link}
//           className="blackButton"
//           data-aos="fade-up"
//           data-aos-delay="300"
//         >
//           Know More
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default EcavoblackComponent;


// EcavoblackComponent.js
// import React from "react";
// import { Link } from "react-router-dom";
// import useIntersectionObserver from "../hooks/useIntersectionObserver";

// const EcavoblackComponent = (props) => {
//   const [ref, inView] = useIntersectionObserver({ threshold: 0.1 });

//   return (
//     <div ref={ref} className={`blackComponentEcavo ${inView ? 'animate' : ''}`}>
//       <img src={props.currrentImg} alt="img2" className="fade-in" />
//       <div className="blackComponentEcavoText">
//         <div className="blackHeading">{props.heading}</div>
//         <p className="blackP">{props.text}</p>
//         <Link to={props.Link} className="blackButton">
//           Know More
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default EcavoblackComponent;